export default {
  appName: 'Read Thai นิยายแปลไทย',
  user: { },
  error: null,
  loading: false
}
